import { render, staticRenderFns } from "./152.vue?vue&type=template&id=d0127888&scoped=true&"
import script from "./152.vue?vue&type=script&lang=js&"
export * from "./152.vue?vue&type=script&lang=js&"
import style0 from "./152.vue?vue&type=style&index=0&id=d0127888&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0127888",
  null
  
)

export default component.exports